import React from 'react'
import classNames from 'classnames'
import { isPastTime } from 'src/utils/helpers/GeneralHelpers'
import {
  otherEvaluationsCompletedInTimeblock,
  p2PSessionCheckForScheduledMeetings
} from 'src/utils/helpers/SessionHelperMethods'
import { useGlobalContext } from 'src/stores/GlobalContext'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import HorizontalLine from 'src/components/Elements/HorizontalLine'
import SessionRegButton from './SessionRegButton'
import FeedbackButton from './FeedbackButton'

const AgendaDetailHeader = ({ currentEvent, session }) => {
  const { attendee, currentUser, sessions } = useGlobalContext()
  const isFullAgenda =
    currentEvent?.event_agenda_status_key === 'event_agenda_status_full_agenda'

  const P2PSessionCheckForMeetings = (session) => {
    // only return p2p session eval button if there is at at least one meeting scheduled
    if (session.session_type_key === 'session_type_one_to_one_meeting') {
      return p2PSessionCheckForScheduledMeetings(session)
    } else {
      return true
    }
  }

  const renderActionButton = () => {
    if (isPastTime(session.epoch_start_time)) {
      if (
        (!otherEvaluationsCompletedInTimeblock(sessions, session) ||
          session.evaluation_completed) &&
        P2PSessionCheckForMeetings(session) &&
        currentUser?.can_take_session_survey &&
        (session?.is_checked_in ||
          session?.session_type_key === 'session_type_one_to_one_meeting')
      ) {
        return <FeedbackButton session={session} detailView={true} />
      }
    } else {
      return (
        <SessionRegButton
          attendee={attendee}
          currentEvent={currentEvent}
          detailView={true}
          session={session}
        />
      )
    }
  }

  return (
    <div>
      <div>
        <span className={fontStyles.pxsmallboldlsssinneutral08onyxgartnersans12pt}>
          {session?.session_type}
        </span>
      </div>

      <div className={generalStyles.mt10}>
        <span className={fontStyles.pdefaultboldlsgartnersans18pt}>
          {session?.name}
        </span>
      </div>

      <div className={generalStyles.mt10}>
        <span className={fontStyles.pxsmalllsssinneutral08onyxgartnersans12pt}>
          {session?.formatted_display_date} | {session?.formatted_display_time}
        </span>
      </div>
      <div>
        <span className={fontStyles.pxsmalllsssinneutral08onyxgartnersans12pt}>
          {session?.room_name}
        </span>
      </div>
      {isFullAgenda && (
        <>
          <div className={classNames(generalStyles.mt20, generalStyles.mb10)}>
            <HorizontalLine color={'neutral03e1e8f4'} fullWidth={true} />
          </div>
          <div
            className={classNames(
              generalStyles.mb10,
              generalStyles.minHeight35
            )}
          >
            {attendee && attendee?.is_approved && renderActionButton()}
          </div>
        </>
      )}
      {!isFullAgenda && (
        <div className={classNames(generalStyles.mt20, generalStyles.mb10)} />
      )}
      <HorizontalLine color={'neutral03e1e8f4'} fullWidth={true} />
    </div>
  )
}

export default AgendaDetailHeader
